module.exports = __webpack_public_path__ + "static/svn-vs-git-e6e6db97a53bdf932299bfc73aaca1b4.jpeg";